/** Every key playback keeps in `env.store`. All of it is the signed-in account's. */
export const PLAYBACK_STORAGE_KEYS = {
    volume: 'playbackVolume',
    playbackRate: 'playbackRate',
    audiobookPlaybackRate: 'audiobookPlaybackRate',
    streamingSettings: 'streamingQualitySettings',
    queueRestore: 'queueRestore.v1',
    pendingMetrix: 'pendingMetrix.playback',
    vinylCatalogOpenStream: 'openStream.vinylCatalog',
    vinylMediaOpenStream: 'openStream.vinylMedia',
    vinylCatalogPendingMtsEvents: 'pendingMtsEvents.vinylCatalog',
    vinylMediaPendingMtsEvents: 'pendingMtsEvents.vinylMedia',
} as const

/** Vinyl writes these through vinyl-util's `persistenceRef`, which a host's `env.store` may not back. */
export const VINYL_PERSISTENCE_KEYS = [
    PLAYBACK_STORAGE_KEYS.vinylCatalogPendingMtsEvents,
    PLAYBACK_STORAGE_KEYS.vinylMediaPendingMtsEvents,
] as const
